import React from 'react';

import ToggleCheck from '@/assets/icons/toggleCheck';
import ToggleCross from '@/assets/icons/toggleCross';
import { Switch } from '@/components/Switch';
import { ds } from '@/components/lib/design.system';
import { useGameSettingsStore } from '@/feature/game-details-arcade/hooks/use-game-settings';
import { designSystem } from '@/styles/styles';

export const BetrBucksToggle = () => {
    const useBetrBucks = useGameSettingsStore(state => state.useBetrBucks);
    const toggleBetrBucks = useGameSettingsStore(state => state.actions.toggleBetrBucks);

    return (
        <Switch
            val={useBetrBucks}
            handleOnPress={toggleBetrBucks}
            onIcon={<ToggleCheck />}
            offIcon={<ToggleCross />}
            activeTrackColor={ds.colorValue.background.brand.emphasis}
            inactiveTrackColor={designSystem.colors.neutral600}
        />
    );
};
